import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var PhoneOutlineSVG = function PhoneOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26.35 2.78L20.63 2a1.75 1.75 0 00-1.91 1.16l-2 6.21a1.71 1.71 0 00.69 2l3.24 2.14c-.53 2.33-.82 4.72-5 7.59l-2.86-2.5a1.76 1.76 0 00-2.08-.31l-5.8 3.11a1.72 1.72 0 00-.82 2.06l1.82 5.41A1.74 1.74 0 007.73 30c14-1.29 21.44-11.82 20.12-25.71a1.72 1.72 0 00-1.5-1.51zM7.6 28.29l-1.81-5.35 5.75-3.08 3.78 3.44c5.08-3 6.27-6 7.45-10.51L18.41 9.9l2-6.13 5.66.76c1.21 12.88-5.42 22.53-18.47 23.76z"
  }));
};
PhoneOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PhoneOutlineSVG);